import { Box, Divider, Typography } from '@mui/material'

/**
 * Titolo di sezione nel form a griglia (full row).
 * @param {{ title: React.ReactNode, sticky?: boolean, compact?: boolean, isMobile?: boolean }} props
 */
export default function FormSectionHeader ({
  title,
  sticky = false,
  compact = false,
  isMobile = false,
}) {
  return (
    <Box
      sx={{
        gridColumn: '1 / -1',
        mt: isMobile ? (compact ? 1 : 1.25) : (compact ? 0.25 : 0.5),
        mb: isMobile ? 0.5 : 0,
        ...(sticky
          ? {
              position: 'sticky',
              top: 0,
              zIndex: 2,
              bgcolor: 'background.paper',
              pt: 0.5,
            }
          : {}),
      }}
    >
      <Typography
        variant="overline"
        component="div"
        sx={{
          fontWeight: 700,
          letterSpacing: '0.06em',
          color: 'text.secondary',
          lineHeight: 1.4,
        }}
      >
        {title}
      </Typography>
      <Divider sx={{ mt: 0.25 }} />
    </Box>
  )
}
